import { gql } from '@apollo/client';
const PRODUCT = gql `
  fragment ProductFragment on ProductNode {
    id
    name
    productDescription
    status
    properName
    isNameEditable
    isSupplierEditable
    isRemovable
    productionTimeDays
    orderOperator {
      id
      name
    }
    pictures {
      edges {
        node {
          id
          image
        }
      }
    }
    supplier {
      id
      code
      shortName
      fullName
    }
    continent {
      id
      name
      description
      thumbnail
    }
    country {
      id
      name
    }
    event {
      id
      name
      description
      thumbnail
    }
    mainCategory {
      id
      name
      description
      thumbnail
    }
    functions {
      edges {
        node {
          id
          name
          description
          thumbnail
        }
      }
    }
    sustainabilities {
      edges {
        node {
          id
          name
          description
          thumbnail
        }
      }
    }
    certificates {
      edges {
        node {
          id
          name
          description
          thumbnail
        }
      }
    }
    zipperType {
      id
      name
      upperSlider
      underSlider
    }
    grammage {
      id
      name
    }
    componentSize {
      id
      name
    }
    width {
      id
      name
    }
    composition {
      id
      name
    }
    producerCode {
      id
      name
    }
    underSliderType {
      id
      name
    }
    upperSliderType {
      id
      name
    }
    yardage {
      id
      name
    }
    category {
      id
      type
      typeLabelPL
      typeLabelEN
      typeIcon
      hasName
      hasComposition
      hasComponentSize
      hasSupplier
      hasProductDescription
      hasWidth
      hasZipperType
      variantHasColor
      variantHasChainColor
      variantHasTapeColor
      variantHasSliderColor
      variantHasSize
      hasGrammage
      hasUpperSliderType
      hasUnderSliderType
      hasProducerCode
      hasYardage
      colorAutoCalculationMethod
      nameAutoCalculationMethod
      precision
    }
    productVariantsCount
    activeProductVariantsCount
    dataHash
    snapshots {
      edges {
        node {
          id
          isUpToDate
        }
      }
    }
  }
`;
export default PRODUCT;
